import { render, staticRenderFns } from "./Template14.vue?vue&type=template&id=08d47bd6&scoped=true&"
import script from "./Template14.vue?vue&type=script&lang=js&"
export * from "./Template14.vue?vue&type=script&lang=js&"
import style0 from "./Template14.vue?vue&type=style&index=0&id=08d47bd6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d47bd6",
  null
  
)

export default component.exports